<template>
	<div class="xs-12">
		<file-system-submenu :bucketName="id" />

		<core-layout-content large>
			<j-card class="xs-12 bg5 mb4 p4 fs3">No data here</j-card>
		</core-layout-content>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import FileSystemSubmenu from "../components/FileSystemSubmenu"

export default {
	name: "FileSystemLogs",

	components: {
		JCard,
		CoreLayoutContent,
		FileSystemSubmenu
	},

	props: {
		// From router
		id: String
	},

	data() {
		return {
			isLoading: false
		}
	}
}
</script>
